var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"loading":_vm.isLoading,"size":"mini","type":"primary"},on:{"click":_vm.downloadGoods}},[_vm._v("\n 导出"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isHideName_this),expression:"!isHideName_this"}]},[_vm._v(_vm._s(_vm.thisUserName)+"的")]),_vm._v("商品  \n  \n \n ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e43070","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadGoodsBtn.vue
// module id = null
// module chunks = 